// Builds the "original message" block appended to a reply sent from the Admin Team
// Inbox / Dev Team boards, so the recipient sees what they wrote above our answer.
export function quoteOriginal(o: { from?: string | null; when?: string | null; subject?: string | null; body?: string | null }): string {
  const text = (o.body || '').replace(/\r\n/g, '\n').trim();
  if (!text) return '';
  const when = o.when ? new Date(o.when) : null;
  const sent = when && !isNaN(when.getTime()) ? when.toLocaleString() : (o.when || '');
  const header = [
    '-----Original Message-----',
    o.from ? `From: ${o.from}` : '',
    sent ? `Sent: ${sent}` : '',
    o.subject ? `Subject: ${o.subject}` : '',
  ].filter(Boolean).join('\n');
  return `${header}\n\n${text.split('\n').map((l) => `> ${l}`).join('\n')}`;
}

// Reply text + quoted original, separated the way a mail client would.
export function withQuote(reply: string, quote: string): string {
  return quote ? `${reply.trimEnd()}\n\n${quote}` : reply;
}
